import { clsx } from 'clsx'

interface ScoreBadgeProps {
  score: string | null
  type?: 'overall' | 'conversion' | 'factor'
}

export function ScoreBadge({ score, type = 'overall' }: ScoreBadgeProps) {
  const getColorClasses = () => {
    if (type === 'overall' || type === 'conversion') {
      switch (score) {
        case 'excellent':
          return 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400'
        case 'good':
          return 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
        case 'medium':
          return 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400'
        case 'low':
          return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400'
        default:
          return 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-500'
      }
    } else {
      // Factor scores (high/medium/low)
      switch (score) {
        case 'high':
          return 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
        case 'medium':
          return 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400'
        case 'low':
          return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400'
        default:
          return 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-500'
      }
    }
  }

  return (
    <span
      className={clsx(
        'inline-block px-2 py-0.5 rounded text-xs font-medium capitalize',
        getColorClasses()
      )}
    >
      {score || '-'}
    </span>
  )
}
